import React, { useContext, useState } from "react";
import { PropTypes } from "prop-types";

import CustomModal from "../../../react_utils/modals/CustomModal";
import { CustomButton } from "../../../react_utils/StyledElements";
import CustomForm from "../../../react_utils/form/CustomForm";
import ModalFooter, {
  ModalFooterWrapper,
} from "../../../react_utils/modals/ModalFooter";
import { AuthContext } from "../../../shared/contexts/AuthContext";
import { MessagingContext } from "../../MessagingContext";
import useClientConfiguration from "../../../shared/hooks/client/useClientConfiguration";
import {
  getEMeterTable,
  getHeatpumpTable,
  getInverterTable,
  getRelayTable,
  getWallboxTable,
} from "./ClientConfigureForm";

export default function ClientConfigureFormModal({
  client,
  resetParent,
  modalProps = {},
}) {
  const { user, apiClient } = useContext(AuthContext);
  const { showMessage } = useContext(MessagingContext);

  const [isFocused, setIsFocused] = useState(false);

  const { form, onReset, onBuffer, onUnassign, onSubmit } =
    useClientConfiguration(
      client,
      resetParent,
      apiClient,
      showMessage,
      getInverterTable,
      getEMeterTable,
      getRelayTable,
      getWallboxTable,
      getHeatpumpTable,
      5000,
      isFocused,
    );

  const onToggle = (isOpen) => {
    setIsFocused(isOpen);
    modalProps.onToggle?.(isOpen);
  };

  const getFooter = (toggle) => {
    if (!client) return null;
    if (client.configured) {
      return (
        <ModalFooterWrapper
          elements={[
            <CustomModal
              title={"Soll das Gerät wirklich zurückgesetzt werden?"}
              key={`reset-confirmation-modal`}
              getOpenButton={(toggle) =>
                user?.is_superuser && (
                  <CustomButton
                    color="error"
                    onClick={toggle}
                    icon="bin"
                    iconColor="error"
                    style={{ width: "100%" }}
                  >
                    Reset
                  </CustomButton>
                )
              }
              getFooter={(_toggle) => (
                <ModalFooter
                  buttons={[
                    {
                      label: "Bestätigen",
                      onClick: async () =>
                        onReset(() => {
                          _toggle();
                          toggle();
                        }),
                    },
                    { label: "Abrechen", onClick: async () => _toggle },
                  ]}
                />
              )}
            />,
          ]}
        />
      );
    }
    return (
      <ModalFooter
        buttons={[
          {
            label: client.configured ? "Speichern" : "Konfigurieren",
            onClick: () => onSubmit(toggle),
          },
          !client.configured &&
            user?.is_superuser && {
              label: "Zuordnung entfernen",
              onClick: () => onUnassign(toggle),
              props: { color: "error" },
            },
          !client.configured && {
            label: "Speichern",
            onClick: () => onBuffer(toggle),
          },
        ]}
      />
    );
  };

  const modalTitle = form.form?.configured
    ? `Steuergerät ${form.form?.serial || ""}`
    : `Steuergerät ${form.form?.serial || ""} konfigurieren`;

  return (
    <>
      <CustomModal
        size="lg"
        title={modalTitle}
        getFooter={getFooter}
        {...modalProps}
        onToggle={onToggle}
      >
        <CustomForm
          template={form.template}
          form={form.form}
          setForm={form.setForm}
          showMissingFields={form.showMissingFields}
        />
      </CustomModal>
    </>
  );
}

ClientConfigureFormModal.propTypes = {
  client: PropTypes.object,
  resetParent: PropTypes.func,
  modalProps: PropTypes.object,
};
